<template>
    <div>
        <span class="go-index" @click="gotoPage()">返回</span>
        <div class="gc-list"> 
            <h3 style="text-align:center;margin-top: 3rem;padding-bottom: 0.5rem;border-bottom: 1px solid #efefef;">《关于我们》</h3>
            <p style="text-indent:1.6rem;line-height: 1.2rem;">这里有一群有趣的"小伙伴"，每周组织各种联谊活动。发展至今已有成员资料 6000+，其中大多为高学历高收入的优秀单身青年。身份核实，审查严格。通过实名制和熟人邀请构建可靠关系网络，为小伙伴营造一个“真实-靠谱-友好”的脱单氛围。</p>
            <p style="text-indent:1.6rem;line-height: 1.2rem;">我们鼓励"小伙伴们"积极脱单，加入我们可以一起吃喝玩乐，参加讲座、读书会，组织羽毛球、野餐、户外爬山徒步等社交活动。除了参加活动还有各种群组话题(情感、美妆、穿搭、脱单技巧)等着你一起学习交流。在轻松愉悦的氛围下交流认识，脱单机率将大大增加。若小伙伴积极脱单还可申请推荐认识(不限次数且免费)。</p>
            <!-- <p style="text-indent:1.6rem;">一路走来实属不易，感谢支持美遇的每一个你！</p> -->


            <h3 style="text-align:center;margin-top: 3rem;padding-bottom: 0.5rem;border-bottom: 1px solid #efefef;">《招募小伙伴啦》</h3>
            <p style="text-indent:1.6rem;line-height: 1.2rem;">目前我们正在招募志愿者，主要负责现场维持/活动组织工作(脱单资源支持)，以及脱单后援会(包含“穿搭”，“美妆”，“情感”，“脱单技巧”等小组)，欢迎感兴趣的小伙伴可以加入我们(联系小美meet2048)。</p>


            <img src="www.symeet.xyz/vue/mp-follow-21.10.18.jpg" style="display: block;width: 16rem; margin: 0 auto;">

            <h3 style="text-align:center;margin-top: 3rem;padding-bottom: 0.5rem;border-bottom: 1px solid #efefef;">《往期展示》</h3>
            <img src="www.symeet.xyz/vue/act-210814/yue01.jpg" style="opacity: 1;display: block; width: 19rem; margin: 0.5rem auto; border-radius: 0.2rem;">
            <img src="www.symeet.xyz/vue/act-210814/yue02.jpg" style="opacity: 1;display: block; width: 19rem; margin: 0.5rem auto; border-radius: 0.2rem;">
            <!-- <img src="www.symeet.xyz/vue/act-210814/yue03.jpg" style="opacity: 1;display: block; width: 19rem; margin: 0.5rem auto; border-radius: 0.2rem;"> -->
            <img src="www.symeet.xyz/vue/act-04-18.jpg" style="opacity: 1;display: block; width: 19rem; margin: 0.5rem auto; border-radius: 0.2rem;">
            <img src="www.symeet.xyz/vue/act-03-21.jpg" style="opacity: 1;display: block; width: 19rem; margin: 0.5rem auto; border-radius: 0.2rem;">
            <img src="www.symeet.xyz/vue/act-01-10.jpg" style="opacity: 1;display: block; width: 19rem; margin: 0.5rem auto; border-radius: 0.2rem;">
            
            <br>
            <br>
            <br>
        </div>
        <!-- <foot /> -->

        <!-- 组件使用 -->
        <syalert ref="syalert_id" />

    </div>
</template>

<script>
    
    // 组件引入
    //import sy from "@/sy";
    //import syalert from '@/components/syalert.vue';
    //import foot from '@/components/foot.vue';

    export default {
        name: 'about',
        components: {
            //foot,
            //syalert,
        },
        data() {
            return {
            }
        },
        methods:
        {
            gotoPage: function(page) {
                if( page !== undefined )
                {
                    this.$router.push(page);
                }else{
                    this.$router.go(-1);
                }
            },
            check:function()
            {
            },
        },
        created(){
            this.check();
        },
    }
</script>

<style>
    .gc-list {
        padding: 0.1rem 0.5rem;

    }

    .gc-list>p {
        font-size: 0.8rem;
    }
</style>